import Perfil from "Components/Perfil";

const PerfilAdmin = () => {
  return (
    <>
      <Perfil isAdmin={true} />
    </>
  );
};

export default PerfilAdmin;
